import { Airport } from "shared/types/airportsTypes";

export const topNationalOriginsData: Airport[] = [
  {
    description: "São Paulo - Todos os aeroportos (SAO), Brasil",
    name: "São Paulo",
    code: "SAO",
  },
  {
    description: "Brasília - Brasília Intl (BSB), Brasil",
    name: "Brasília",
    code: "BSB",
  },
  {
    description: "Rio de Janeiro - Todos os aeroportos (RIO), Brasil",
    name: "Rio de Janeiro",
    code: "RIO",
  },
  {
    description: "Belo Horizonte - Todos os aeroportos (BHZ), Brasil",
    name: "Belo Horizonte",
    code: "BHZ",
  },
  {
    description: "Recife - Guararapes Intl (REC), Brasil",
    name: "Recife",
    code: "REC",
  },
];
